export default __webpack_public_path__ + "static/media/1.7667c02d.jpg";